import _Vue from 'vue'
const WebIME = require('../../public/student/webime/webime.min.js')

export default {
  install(Vue: typeof _Vue) {
    const webime = new WebIME()
    webime.globalSetting = {
      softwareKeyboardTheme: 'dark',
      softwareKeyboardAlign: 'center',
      isLimitedJoyoKanji: false,
      jp50Type: 'right',
      candidatesDisplayRandom: false,
      candidatesDisplayFilter: true,
      closeOnBlur: true,
      useConversion: true,
      useRelationalConversion: true,
      useSoftwareKeyboard: true,
      usePrediction: true,
      softwareKeyboardKeyRepeatDelay: 200,
      softwareKeyboardKeyRepeatInterval: 60,
      hardwareKeyboardDisplayDuration: 3000,
      vendor: 'vendor_combine_webime',
      sessionID: undefined,
      useLearning: true,
      isUserAccountAvailable: false,
      userIDs: [],
      productOwner: 'combine',
      authKey: 'jQ*56%9m',
      modelName: '教育向け',
      productKeys: ['webime_education_common'],
      showUseSoftwareKeyboard: false,
      cloudWnnURL: 'https://cloud-staging.wnnlab.com/',
      keyboards: ['math', 'math_primaryschool_lowerelementary', 'math_primaryschool_upperelementary', 'science'],
      fontsDirectory: './fonts',
      publicPath: '/student/webime',
    }
    Vue.prototype.$webime = webime
  },
}
